import { inject, InjectionToken, Provider, Type } from '@angular/core';

import { addEntryToRegistry, AsyncRegistry, AsyncRegistryInitializer, MaybePromise, provideRegistry } from '@kros-sk/core/registry';

import { SchemaComponentBaseComponent } from './schema-component-base.component';

export type SchemaComponentsRegistry = AsyncRegistry<Type<SchemaComponentBaseComponent>>;

export type SchemaComponentEntry = AsyncRegistryInitializer<Type<SchemaComponentBaseComponent>>;

export const SCHEMA_COMPONENTS_REGISTRY = new InjectionToken<SchemaComponentsRegistry>('SCHEMA_COMPONENTS_REGISTRY');

/**
 * `config` and `state` are `input()`s and therefore invariant, so a component narrowing either
 * generic is not assignable to `Type<SchemaComponentBaseComponent>`. The check that matters is that
 * the component really derives from the base; this keeps the resulting widening in one place.
 */
export function addSchemaComponentToRegistry<TConfig, TData>(
  key: string,
  load: () => Type<SchemaComponentBaseComponent<TConfig, TData>> | Promise<Type<SchemaComponentBaseComponent<TConfig, TData>>>
): SchemaComponentEntry {
  return addEntryToRegistry<MaybePromise<Type<SchemaComponentBaseComponent>>>(
    key,
    () => load() as Type<SchemaComponentBaseComponent> | Promise<Type<SchemaComponentBaseComponent>>
  );
}

export function provideSchemaComponents(...initializers: SchemaComponentEntry[]): Provider {
  return provideRegistry(SCHEMA_COMPONENTS_REGISTRY, ...initializers);
}

export function injectSchemaComponents(): SchemaComponentsRegistry {
  return inject(SCHEMA_COMPONENTS_REGISTRY);
}
